module.exports = __webpack_public_path__ + "media/images/pie/escu_centro2-f47d21da7bdae283b32800e4737135bc.png";